const MAINTENANCE_COMPLETION_TARGET = 1;
const ON_TIME_RESPONSE_TARGET = 0.8;
const REGULAR_CALLBACK_RATE_TARGET = 4;
const EMERGENCY_CALLBACK_RATE_TARGET = 3;

export const targets = {
  maintenanceCompletion: MAINTENANCE_COMPLETION_TARGET,
  onTimeResponse: ON_TIME_RESPONSE_TARGET,
  regularCallbackRate: REGULAR_CALLBACK_RATE_TARGET,
  emergencyCallbackRate: EMERGENCY_CALLBACK_RATE_TARGET,
} as const;
